import React from 'react';
import { Helmet } from 'react-helmet-async';

// Production domain — used in canonical and og:url.
const SITE_URL = 'https://www.cardonaautodetailing.com';

/**
 * Per-page meta tags. react-snap captures these during pre-render, so each
 * route ends up with its own title, description and canonical URL.
 */
export default function Seo({ title, description, path = '/' }) {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
